<script>
import { userRoute } from '@src/router'
import { useIndexStore } from '@src/store'

export default {
  name: 'Toolbar',
  computed: {
    store () {
      return useIndexStore()
    },
    userName () {
      const user = this.store.user || null
      return user ? user.fullName : '/'
    },
  },
  methods: {
    handleChangeLanguage (lang) {
      this.$vuetify.locale.current = lang
      this.$language.current = lang
    },
    handleUserClick () {
      this.$router.push({ name: userRoute.name })
    },
  },
}
</script>
<template>
  <v-toolbar
    class="app-toolbar"
    :elevation="4"
    density="compact"
    color="white"
  >
    <img
      class="logo"
      src="@static/climateplus-logo.png"
      alt="Climateplus"
    >
    <div class="toolbar-buttons-container">
      <v-tooltip
        location="left"
        color="secondary"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            size="small"
            :style="{marginRight: '40px'}"
            v-bind="props"
            color="secondary"
            icon="fas fa-user"
            @click="handleUserClick"
          />
        </template>
        <span>{{ userName }}</span>
      </v-tooltip>
      <div
        v-for="(language, lang) in $language.available"
        :key="lang"
        class="language"
        :class="[lang === $language.current ? 'active' : '']"
        :title="language"
        @click="handleChangeLanguage(lang)"
      >
        {{ lang.toUpperCase() }}
      </div>
    </div>
  </v-toolbar>
</template>
<style lang="scss" scoped>
.app-toolbar {
  z-index: 100;
  height: 50px !important;
  padding-left: 20px;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  position: relative;
}
.logo {
  height: 70%;
}
.project-name {
  font-size: 1.3em;
}
.toolbar-buttons-container {
  display: flex;
}
.language {
  width: 50px;
  display: flex;
  color: $grey-light;
  border-right: 1px solid $grey-light;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  cursor: pointer;
}
.language.active,
.language:hover {
  color: $secondary;
}
.language:last-child {
  border-right: 0;
}
</style>
